
// import { GithubContributions } from "react-github-graph"

import Tooltip from '@uiw/react-tooltip';
import HeatMap from '@uiw/react-heat-map';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { GitHub } from '@mui/icons-material';

const GithubGraph = () => {
    const [gitLabvalue, setGitLabvalue] = useState([])
    const [gitHubvalue, setGitHubvalue] = useState([])
    const [selected, setSelected] = useState('')
    const [range] = useState(5)

    useEffect(() => {
        (async () => {
            const resp = await axios.get('https://cors-proxy4.p.rapidapi.com/', {
                params: { url: 'https://gitlab.com/users/hundaguluma/calendar.json' },
                headers: {
                    'X-RapidAPI-Key': '30795c3e2fmsh64da49438a95d03p156519jsn19472b2533cc',
                    'X-RapidAPI-Host': 'cors-proxy4.p.rapidapi.com'
                }
            })
            const resp2 = await axios.get('https://github-contributions-api.jogruber.de/v4/hundag20?y=last')
            const outputArray = Object.entries(resp.data).map(([date, count]) => ({
                date: date.replace(/-/g, '/'),
                count: count
            }));
            setGitLabvalue(outputArray)
            setGitHubvalue(resp2.data.contributions)
        })()
    }, [])
    return (
        <div>
            <div style={{ display: 'flex', margin: 'auto', width: '80%' }}>
                <GitHub />
                <HeatMap
                    width={
                        '100%'
                    }
                    value={gitHubvalue}
                    weekLabels={['', 'Mon', '', 'Wed', '', 'Fri', '']}
                    startDate={new Date('2023/01/01')}
                    endDate={new Date()}
                    rectRender={(props, data) => {
                        if (selected !== '') {
                            props.opacity = data.date === selected ? 1 : 0.15
                        }
                        return (
                            <Tooltip trigger={selected && (data.date === selected) ? 'click' : 'hover'} isOpen={(selected && (data.date === selected)) ? true : false} placement="top" content={`count: ${data.count || 0}`}>
                                <rect {...props} onClick={() => {
                                    setSelected(data.date === selected ? '' : data.date);
                                }} />
                            </Tooltip>
                        );
                    }
                    }
                />
            </div>
            <div style={{ display: 'flex', margin: 'auto', width: '80%' }}>
                <img src="/gitlab.PNG" style={{
                    width: '1em',
                    height: '1em',
                    fontSize: '1.5rem'
                }}></img>
                <HeatMap
                    width={
                        '80%'
                    }
                    panelColors={{
                        0: '#f4decd',
                        2: '#e4b293',
                        4: '#d48462',
                        10: '#c2533a',
                        20: '#ad001d',
                        30: '#000',
                    }}
                    value={gitLabvalue}
                    weekLabels={['', 'Mon', '', 'Wed', '', 'Fri', '']}
                    startDate={new Date('2023/01/01')}
                    endDate={new Date()}
                    legendRender={(props) => <rect {...props} y={props.y + 10} rx={range} />}
                    rectProps={{
                        rx: range
                    }}
                    rectRender={(props, data) => {
                        if (selected !== '') {
                            props.opacity = data.date === selected ? 1 : 0.15
                        }
                        return (
                            <Tooltip trigger={selected && (data.date === selected) ? 'click' : 'hover'} isOpen={(selected && (data.date === selected)) ? true : false} placement="top" content={`count: ${data.count || 0}`}>
                                <rect {...props} onClick={() => {
                                    setSelected(data.date === selected ? '' : data.date);
                                }} />
                            </Tooltip>
                        );
                    }
                    }
                />
            </div>
        </div >
    )
};
export default GithubGraph;